/* eslint-disable @typescript-eslint/no-explicit-any */

import dayjs from 'dayjs';
import {ContratServices} from '../../services/applicatif/contrat';
import {RapatriementServices} from '../../services/applicatif/rapatriement';
import {retraiteService} from '../../services/applicatif/retraite';
import {VoyageServices} from '../../services/applicatif/voyages';
import {DEFAULT_RIP_AGENCE} from '../constants/Assurance/AssuranceRapatriement/souscription';
import {ApiResponse} from '../types/interface/api';
import {RapatriementModifDTO} from '../types/interface/Assurance/AssuranceRapatriement/souscription';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const {createContrat, renewContrat} = RapatriementServices();

const sendScolaire = (props: any) => {
  const {scolaireContrat, okCompletion, showError, setIsLoading} = props;
  const {contratEC} = props.user;
  scolaireContrat(contratEC, (res: any) => {
    console.log('res sendScolaire', res);
    if (res && !res.isError && res.data) {
      setIsLoading();
      okCompletion({
        id: res.data.id,
        title: 'Assurance Scolaire',
        numeroPolice: res.data.numeroPolice,
      });
    } else {
      showError(res.message);
    }
  });
};

const sendRcvp = (props: any) => {
  const {rcvpContrat, okCompletion, showError} = props;
  const {contratEC} = props.user;
  rcvpContrat(contratEC, (res: any) => {
    console.log('res sendRCVP', res);
    if (res && !res.isError && res.data) {
      okCompletion({
        id: res.data.id,
        title: 'Assurance RC Vie Privée',
        numeroPolice: res.data.numeroPolice,
      });
    } else {
      showError(res.message);
    }
  });
};

const deleteSimulationRcvp = (props: any) => {
  const {showError, okCompletion} = props;
  const {deleteRcvp} = ContratServices();
  const {contratEC} = props.user;
  deleteRcvp(contratEC.simulationId).then((res: any) => {
    if (res && !res.isError && res.data) {
      okCompletion({
        title: getTitle(contratEC.typeContrat),
        numeroPolice: contratEC.numeroPolice,
      });
    } else {
      showError(res.message);
    }
  });
};

const deleteSimulationScolaire = (props: any) => {
  const {showError, okCompletion} = props;
  const {deleteScolaire} = ContratServices();
  const {contratEC} = props.user;
  deleteScolaire(contratEC.simulationId).then((res: any) => {
    if (res && !res.isError && res.data) {
      okCompletion({
        title: getTitle(contratEC.typeContrat),
        numeroPolice: contratEC.numeroPolice,
      });
    } else {
      showError(res.message);
    }
  });
};

const deleteSimulationRattache = (props: any) => {
  const {showError, okCompletion} = props;
  const {deleteContrat} = ContratServices();
  const {contratEC} = props.user;
  deleteContrat({id: contratEC.simulationId}).then((res: any) => {
    if (res && !res.isError && res.data) {
      okCompletion({
        title: getTitle(contratEC.typeContrat),
        numeroPolice: contratEC.numeroPolice,
      });
    } else {
      showError(res.message);
    }
  });
};

const sendRetraite = (props: any) => {
  const {okCompletion, showError, setIsLoading} = props;
  const {contratEC, numeroPolice} = props.user;
  if (numeroPolice) {
    contratEC.formData.append('numeroPolice', numeroPolice);
    console.log('format data with numeroPolice', contratEC.formData);
  }
  retraiteService()
    .souscrire(contratEC.formData)
    .then((res: any) => {
      const response = res.data;
      if (response && !response.isError && response.data) {
        okCompletion({
          id: response.data.id,
          title: 'Assurance Retraite',
          numeroPolice: response.data.numeroPolice,
        });
      } else {
        console.log('CREATION RETRAITE ERROR', res);
        showError(res.message);
      }
      setIsLoading(false);
    });
};

const getNumeroPoliceVoyage = (props: any) => {
  const {okCompletion, setIsLoading, user, showError} = props;
  VoyageServices()
    .getPolicyNumberByQuoteCode(user.contratEC.simulationId)
    .then((res: any) => {
      setIsLoading();
      if (!res.isError) {
        okCompletion({
          id: res.data.numeroPoliceAxa,
          title: `Assurance Voyage`,
          numeroPolice: res.data.numeroPolice,
        });
      } else {
        showError(res.message);
      }
    })
    .catch((error: any) => {
      console.log('error get policy number', error);
    });
};

const createRapatriement = (params: any) => {
  const {okCompletion, setIsLoading, user, showError} = params;

  setIsLoading();
  createContrat(user.contratEC.simulationId)
    .then((res: ApiResponse) => {
      console.log(res);

      setIsLoading();
      if (!res.isError) {
        okCompletion({
          id: res.data.policyNumber,
          title: `Assurance Obsèques à Dago`,
          numeroPolice: res.data.policyNumber,
        });
      } else {
        showError(res.message);
      }
    })
    .catch((error: any) => {
      console.log('error get policy number', error);
    });
};

const okPayment = (props: any) => {
  const {okCompletion} = props;
  const {contratEC} = props.user;
  if (contratEC.typeContrat !== 'voyage') {
    okCompletion({
      title:
        contratEC.typeContratPayment === 'retraite'
          ? 'Cotisation Retraite'
          : `ASSURANCE ${
              contratEC.typeContratPayment?.toUpperCase() ||
              contratEC.typeContrat?.toUpperCase()
            }`,
      typeContrat: contratEC.typeContratPayment,
    });
  } else {
    okCompletion(props);
  }
};

const getTitle = (typeContrat: string) => {
  switch (typeContrat) {
    case 'scolaire':
      return 'Assurance Scolaire';
    case 'rcvp':
      return 'Assurance RC Vie Privée';
    default:
      return typeContrat;
  }
};

export const formatDataForRapatriementRenewal = (
  contrat: RapatriementModifDTO,
) => {
  const formattedData = {
    simulation_id: contrat.simulationId,
    amount: contrat.montant,
    contract_id: contrat.numeroPolice,
    assured_ids: contrat.assure.map(a => ({
      name: `${a.nom} ${a.prenom}`,
      date_of_birth: dayjs(a.dateNaissance).format('YYYY-MM-DD'),
      email: a.email,
      country_id: a.paysResidence,
    })),
    contribution_type: 'Avenant',
    agence: DEFAULT_RIP_AGENCE,
  };
  return formattedData;
};

export const confirmRapatriementRenewal = (props: any) => {
  const {okCompletion, showError} = props;
  const {contratEC} = props.user;

  const contrat: RapatriementModifDTO = contratEC.rapatriement;
  const transactionId = contratEC.transactionId;

  renewContrat(contrat, transactionId)
    .then((res: ApiResponse) => {
      if (res && !res.isError && res.data) {
        okCompletion({
          id: res.data.policyNumber,
          title: `Assurance Obsèques à Dago`,
          numeroPolice: res.data.policyNumber,
        });
      } else {
        if (res.isError) {
          showError(res.message);
        }
      }
    })
    .catch(err => {
      console.log(err);
      showError(err.message);
    });
};

// TODO: ampiana nen"i rapatriement
export const sendInfo = (props: any) => {
  const {contratEC} = props.user;

  if (
    contratEC.typeContrat === 'rcvp' &&
    contratEC.typePayment === 'souscription'
  ) {
    sendRcvp(props);
  } else if (
    contratEC.typeContrat === 'scolaire' &&
    contratEC.typePayment === 'souscription'
  ) {
    sendScolaire(props);
  } else if (
    contratEC.typeContrat === 'retraite' &&
    contratEC.typePayment === 'souscription'
  ) {
    sendRetraite(props);
  } else if (contratEC.typeContrat === 'voyage') {
    getNumeroPoliceVoyage(
      contratEC ? props : {user: {contratEC: {quoteCode: props.quoteCode}}},
    );
  } else if (
    contratEC.typeContrat === 'rapatriement' &&
    contratEC.typePayment == 'souscription'
  ) {
    createRapatriement(props);
  } else if (
    contratEC.typeContrat === 'rcvp' &&
    contratEC.typePayment == 'renouvellement'
  ) {
    deleteSimulationRcvp(props);
  } else if (
    contratEC.typeContrat === 'scolaire' &&
    contratEC.typePayment === 'renouvellement'
  ) {
    deleteSimulationScolaire(props);
  } else if (
    (contratEC.typeContrat === 'rattache' ||
      contratEC.typeContrat === 'monovehicule') &&
    contratEC.typePayment === 'renouvellement'
  ) {
    deleteSimulationRattache(props);
  } else if (
    contratEC.typeContrat === 'rapatriement' &&
    contratEC.typePayment == 'renouvellement'
  ) {
    confirmRapatriementRenewal(props);
  } else {
    okPayment(props);
  }
};
